import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 21 21",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path clip-rule="evenodd" d="M18.4 5.609c0-.613-.515-1.109-1.152-1.109H3.552c-.636 0-1.152.496-1.152 1.109v8.782c0 .613.516 1.109 1.152 1.109h13.696c.637 0 1.152-.496 1.152-1.109V5.61Z" stroke="currentColor" stroke-width="1.5" /> <path clip-rule="evenodd" d="M8.4 4.5h4v4h6v3h-6v4h-4v-4h-6v-3h6v-4Z" stroke="currentColor" stroke-width="1.5" /> <path d="m2.9 5 5.5 3.5m4 3 5 3.5m-5-6.5L17.9 5m-15 10 5.5-3.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />' }
  })
);